import { useEffect, useState } from 'react';
import {
    cloneDeep,
} from 'lodash';

import {
    initEditorUI,
    cleanEditorUI,
    createImage,
} from './elements';

import {
    defaultLimits,
} from './engineCore';

import {
    initState,
    getRelativeBounds,
    initContentState,
} from './engineState';

import {
    renderWorkspace,
} from './engineRenderer';

import {
    attachMouseEvents,
    dispatchChangeEvent,
} from './engineListeners';

import {
    updateEditorStateLimits,
} from './engineStateHelper';

import { useButtonsStore } from '../../store/models';

function useImageEditor (props) {
    const {
        imageSource,
        onChangeComplete,
        shape,
        limits = { ...defaultLimits },
        onImageEditorMounted,
    } = props;

    const buttonsStore = useButtonsStore();
    const [image, setImage] = useState(null);

    useEffect(() => {
        window.editorScaling = false;
        window.editorOnChangeComplete = onChangeComplete;
        initEditorUI({
            shape,
            onUIMounted,
        });

        return () => {
            cleanEditorUI();
        };
    }, []);

    useEffect(() => {
        updateEditorStateLimits(shape);
        if (buttonsStore.shouldInitEditorStateToDefault()) {
            initState(getRelativeBounds(window.editorUI.workspace), image, shape);
            initContentState(image);
            window.currentEditorState = cloneDeep(window.editorState);
        }
        drawEditor();
    }, [shape]);

    useEffect(() => {
        updateImageBySource();
    }, [imageSource]);

    async function updateImageBySource () {
        try {
            const { image: newImage } = await createImage(imageSource);
            setImage(newImage);
            window.editorUI.image = newImage;
            // only initialized when changes are not coming from the undo / redo or when image is set to default
            // see buttonsStore.shouldInitEditorStateToDefault()
            if (buttonsStore.shouldInitEditorStateToDefault()) {
                initState(getRelativeBounds(window.editorUI.workspace), newImage, shape);
                initContentState(newImage);
                window.currentEditorState = cloneDeep(window.editorState);
            }
            drawEditor();
        } catch (err) {
            console.log('error updating image by source -> ', err);
        }
    }

    async function onUIMounted (uis) {
        window.editorLimits = limits;
        initState(getRelativeBounds(uis.workspace), image, shape);
        if (imageSource) {
            await updateImageBySource();
        } else {
            window.currentEditorState = cloneDeep(window.editorState);
            drawEditor();
        }
        attachMouseEvents(window.editorUI);
        onImageEditorMounted();
    }

    function drawEditor () {
        console.log('drawEditor() -> ', window.editorState);
        renderWorkspace(window.editorState, window.editorUI);
        dispatchChangeEvent();
    }

    return {
        image,
    };
}

export default useImageEditor;
